/* Busca guiada (gaveta #drawer-search-form). Veio do Teste 29.1 (Intelligems), implementado no tema em 16/10/2026.
   Produtos e ordem: busca preditiva da Shopify, já renderizada pelo tema (sections/kuba-search-results.liquid).
   Relacionados: recomendações "related" da Shopify (sections/kuba-search-related.liquid).
   Painel inicial, acessórios mais vendidos, sinônimos e ordem fixa: sections/kuba-search.liquid (editável no editor de tema).
   Nosso aqui: separar quem tem o termo no nome, aplicar sinônimos e ordem fixa, ajuda por intenção e montar o layout.
   Enter não faz nada (a página /search ficou fora da busca guiada). */
(function () {
  // Ligado para todos. Para desligar e voltar à gaveta do tema, troque para false.
  var LIVE = true;
  try {
    if (/[?&]kbs=1/.test(location.search)) sessionStorage.setItem('kbsPreview', '1');
    if (/[?&]kbs=0/.test(location.search)) sessionStorage.removeItem('kbsPreview');
    if (!LIVE && sessionStorage.getItem('kbsPreview') !== '1') return;
  } catch (e) { if (!LIVE) return; }
  if (window.__kbBuscaGuiada) return;
  window.__kbBuscaGuiada = true;

  var cfgEl = document.getElementById('kbs-config');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}

  function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  // "estojo, capa = case" -> { estojo: 'case', capa: 'case' }; "case = a, b, c" -> { case: ['a','b','c'] }
  function rules(text, many) {
    var out = {};
    (text || '').split(/\n+/).forEach(function (line) {
      var parts = line.split('=');
      if (parts.length < 2) return;
      var left = parts[0].split(','), right = parts.slice(1).join('=');
      if (many) out[norm(left[0])] = right.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      else left.forEach(function (w) { if (norm(w)) out[norm(w)] = right.trim(); });
    });
    return out;
  }
  var SYN = rules(CFG.synonyms, false);
  var PINS = rules(CFG.pins, true);
  // "headphone, tws = handle-da-coleção": busca de categoria mostra a coleção, na ordem dela
  var CATS = rules(CFG.cats, false);
  var CAT_ORDER = rules(CFG.cat_order, true);
  var HIDE_IN_CATS = {}; (CFG.hide_in_cats || []).forEach(function (h) { if (h) HIDE_IN_CATS[h] = 1; });
  var BEST = CFG.best || [];
  var SUPPORT = { title: (CFG.support && CFG.support.title) || 'Suporte, pedidos e garantia', url: (CFG.support && CFG.support.url) || '/pages/suporte' };
  var MAIN_TYPES = /^(headphones|intra-auriculares|caixa de som)$/i;
  var HELP = [
    { re: /suporte|garantia|manual|devolu|troca|cancel|pedido|rastre|entrega|prazo|compra|\bapp\b|configur|como |reset|fale|chat|contato/i, title: SUPPORT.title, url: SUPPORT.url },
    { re: /cupom|desconto|oferta|promo|coupon/i, title: 'Frete grátis acima de R$ 199 e 6x sem juros', url: '/collections/all' }
  ];
  // "acessório(s)" sozinho: acessórios mais vendidos. "acessórios para mali" (ou "acessorio uni", "acessórios do disco"):
  // acessórios da coleção de acessórios que têm o nome do fone no título, sem o fone em si.
  var ACC = /^acessorios?(?:\s+(?:para|pra|pro|p\/|do|da|de|dos|das))?\s*(.*)$/;
  var ACC_SET = {}; (CFG.acc_all || []).forEach(function (h) { if (h) ACC_SET[h] = 1; });
  var REC_MAX = 6, REL_MAX = 4;

  function effective(q) { return SYN[norm(q)] || q; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function inTitle(title, q) {
    var t = norm(title), toks = norm(q).split(' ').filter(Boolean);
    if (!toks.length) return false;
    return t.indexOf(norm(q)) > -1 || toks.some(function (k) { return k.length > 1 && t.indexOf(k) > -1; });
  }
  // produtos vêm prontos do tema: dados no .kbs-item e o HTML do card e da linha em <template>
  function readItems(root) {
    return Array.prototype.map.call(root.querySelectorAll('.kbs-item'), function (el) {
      var c = el.querySelector('template[data-card]'), r = el.querySelector('template[data-row]');
      var card = c ? c.innerHTML : '';
      if (BEST.indexOf(el.dataset.handle) > -1) card = card.replace(/<span class="kbs-tag" hidden(="")?>/, '<span class="kbs-tag">');
      return { handle: el.dataset.handle, id: el.dataset.id, title: el.dataset.title, type: el.dataset.type,
        available: el.dataset.available === 'true', card: card, row: r ? r.innerHTML : '' };
    });
  }
  function readPages(root) {
    return Array.prototype.map.call(root.querySelectorAll('[data-kbs-page]'), function (a) {
      return { title: a.textContent.trim(), url: a.getAttribute('href') };
    });
  }

  function arrange(q, products, pages) {
    var qe = effective(q), key = norm(qe);
    var has = {}; products.forEach(function (p) { has[p.handle] = 1; });
    var intent = HELP.filter(function (h) { return h.re.test(q); }).map(function (h) { return { title: h.title, url: h.url }; });
    var help = intent.slice();
    (pages || []).forEach(function (pg) {
      if (/suporte/i.test(pg.title) && !/pr[eé]-venda/i.test(pg.title) && !help.some(function (h) { return h.url === pg.url; }))
        help.push({ title: pg.title.replace(/ \|.*$/, ''), url: pg.url });
    });
    if (!help.length) help.push(SUPPORT);
    var rec = PINS[key] ? PINS[key].filter(function (h) { return has[h]; }) : [];
    var hits = products.filter(function (p) { return rec.indexOf(p.handle) === -1 && inTitle(p.title, qe); });
    hits.sort(function (a, b) { return (norm(b.title) === key) - (norm(a.title) === key) || b.available - a.available; });
    rec = rec.concat(hits.map(function (p) { return p.handle; }));
    if (!rec.length && !intent.length) rec = products.filter(function (p) { return MAIN_TYPES.test(p.type || ''); }).map(function (p) { return p.handle; });
    rec = rec.slice(0, REC_MAX);
    var rest = products.map(function (p) { return p.handle; }).filter(function (h) { return rec.indexOf(h) === -1; });
    return { rec: rec, rest: rest, help: help.slice(0, 2), zero: !products.length };
  }

  // ---------- rede: HTML das seções do tema, com cache na página e cancelamento da busca anterior ----------
  var memo = {}, ctrl = null;
  function getDoc(url, cancelable) {
    if (memo[url]) return Promise.resolve(memo[url]);
    var opts = {};
    if (cancelable && window.AbortController) { if (ctrl) ctrl.abort(); ctrl = new AbortController(); opts.signal = ctrl.signal; }
    return fetch(url, opts).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var d = new DOMParser().parseFromString(t, 'text/html'); memo[url] = d; return d; });
  }
  function suggest(q) {
    return getDoc('/search/suggest?q=' + encodeURIComponent(effective(q)) +
      '&resources[type]=product,page&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=show' +
      '&section_id=kuba-search-results', true)
      .then(function (d) { return { products: readItems(d), pages: readPages(d) }; });
  }
  function related(id) {
    return getDoc('/recommendations/products?product_id=' + encodeURIComponent(id) + '&intent=related&limit=6&section_id=kuba-search-related', false)
      .then(readItems).catch(function () { return []; });
  }

  // ---------- peças do layout (classes kbs-*) ----------
  var ARROW = '<i class="kbs-arrow" aria-hidden="true"></i>';
  var LUPA = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
  var BACK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';
  function sec(label, inner, cls) { return '<div class="kbs-sec' + (cls ? ' ' + cls : '') + '"><span class="kbs-label">' + label + '</span>' + inner + '</div>'; }
  function links(list) { return list.map(function (l) { return '<a class="kbs-link" href="' + esc(l.url) + '"><span>' + esc(l.title) + '</span>' + ARROW + '</a>'; }).join(''); }
  function cards(list) { return '<div class="kbs-cards">' + list.map(function (p) { return p.card; }).join('') + '</div>'; }

  // ---------- montagem ----------
  function init() {
    var d = document.getElementById('drawer-search-form');
    var input = d && d.querySelector('input[name="q"]');
    var box = d && d.querySelector('[data-results-search]');
    var form = input && input.form;
    var panelTpl = document.getElementById('kbs-panel');
    if (!d || !input || !box || !form || !panelTpl || d.classList.contains('kbs-v')) return !!(d && d.classList.contains('kbs-v'));

    var panel = panelTpl.content;
    var accTpl = document.getElementById('kbs-acc');
    var ACC_ITEMS = accTpl ? readItems(accTpl.content) : [];
    // "tws, true wireless = mali-2": termos que mostram só esses produtos
    var FIXED = {};
    var fixedTpl = document.getElementById('kbs-fixed');
    if (fixedTpl) Array.prototype.forEach.call(fixedTpl.content.querySelectorAll('[data-kbs-terms]'), function (el) {
      var list = readItems(el);
      el.getAttribute('data-kbs-terms').split(',').forEach(function (w) { if (norm(w)) FIXED[norm(w)] = list; });
    });
    function part(sel) { var el = panel.querySelector(sel); return el ? el.outerHTML : ''; }

    // o tema para de buscar e de limpar a gaveta; a busca guiada assume
    d.getSearchResults = function () {};
    d.onChange = function () {};
    d.close = function () {};
    d.classList.add('kbs-v');

    var head = d.querySelector('.hdt-search-head h5');
    if (head) head.textContent = 'Busca';
    input.placeholder = 'Buscar fones, peças e acessórios';
    input.setAttribute('enterkeyhint', 'search');
    var inner = input.parentNode;
    var back = document.createElement('button');
    back.type = 'button'; back.className = 'kbs-back'; back.hidden = true;
    back.setAttribute('aria-label', 'Voltar e começar outra busca'); back.innerHTML = BACK;
    inner.insertBefore(back, input);
    var lupa = document.createElement('span');
    lupa.className = 'kbs-go'; lupa.setAttribute('aria-hidden', 'true'); lupa.innerHTML = LUPA;
    inner.appendChild(lupa);

    // bloco irmão dos resultados: painel inicial e reserva do zero resultado (fora de [data-results-search])
    var extra = document.createElement('div');
    extra.className = 'kbs-extra';
    box.parentNode.insertBefore(extra, box.nextSibling);
    var current = '';

    function renderEmpty() {
      current = '';
      box.innerHTML = '';
      back.hidden = true; inner.classList.remove('kbs-has-back');
      extra.innerHTML = '';
      extra.appendChild(panel.cloneNode(true));
    }

    // top: lista pronta de mais vendidos (busca por acessórios); ocupa o lugar dos recomendados
    function renderResults(q, data, top) {
      top = top || [];
      var a = arrange(q, data.products, data.pages);
      var by = {}; data.products.concat(top).forEach(function (p) { by[p.handle] = p; });
      if (top.length) {
        a.rec = top.map(function (p) { return p.handle; }).slice(0, REC_MAX);
        a.rest = data.products.map(function (p) { return p.handle; }).filter(function (h) { return a.rec.indexOf(h) === -1; });
        a.zero = false;
      }
      var help = sec('Ajuda', links(a.help));
      if (a.zero) {
        box.innerHTML = '<p class="kbs-zero">Não achamos <b>“' + esc(q) + '”</b>. Tente um dos termos mais buscados ou veja os mais vendidos.</p>';
        extra.innerHTML = '<div class="kbs-dk kbs-zerogrid">' + part('[data-kbs-best]') +
          '<div class="kbs-side">' + help + part('[data-kbs-chips]').replace('kbs-sec kbs-all', 'kbs-sec') + '</div></div>';
        return;
      }
      extra.innerHTML = '';
      var recP = a.rec.map(function (h) { return by[h]; });
      var recHtml = recP.length ? sec('Produtos recomendados', cards(recP)) : '';
      box.innerHTML = '<div class="kbs-dk"><div class="kbs-main">' + (recP.length ? recHtml : help) + '</div>' +
        '<div class="kbs-side"><div class="kbs-rel"></div>' + (recP.length ? help : '') + '</div></div>';
      var relBox = box.querySelector('.kbs-rel');
      function fill(list) {
        if (current !== q) return;
        var seen = {}; a.rec.forEach(function (h) { seen[h] = 1; });
        var out = [];
        list.concat(a.rest.map(function (h) { return by[h]; })).forEach(function (p) {
          if (p && !seen[p.handle] && out.length < REL_MAX) { seen[p.handle] = 1; out.push(p); }
        });
        relBox.innerHTML = out.length ? sec('Produtos relacionados', out.map(function (p) { return p.row; }).join('')) : '';
      }
      // busca de acessórios: os relacionados são outros acessórios, não as recomendações da Shopify (que trazem fones)
      if (top.length) fill([]);
      else if (recP.length && recP[0].id) related(recP[0].id).then(fill); else fill([]);
    }

    function run(q) {
      q = (q || '').trim();
      if (!q) { renderEmpty(); return; }
      current = q;
      back.hidden = false; inner.classList.add('kbs-has-back');
      var fixed = FIXED[norm(q)] || FIXED[norm(effective(q))];
      if (fixed && fixed.length) { renderResults(q, { products: [], pages: [] }, fixed); return; }
      var colH = CATS[norm(q)] || CATS[norm(effective(q))];
      if (colH) {
        // busca de categoria: produtos da coleção (disponíveis primeiro); os 6 primeiros recomendados, o resto relacionados
        getDoc('/collections/' + encodeURIComponent(colH) + '?section_id=kuba-search-collection', true).then(function (doc) {
          if (current !== q) return;
          var items = readItems(doc).filter(function (p) { return !HIDE_IN_CATS[p.handle]; });
          // ordem fixa da categoria na frente; o resto segue a ordem da coleção
          var order = CAT_ORDER[norm(colH)] || [];
          var pos = function (p) { var i = order.indexOf(p.handle); return i < 0 ? order.length : i; };
          items = items.map(function (p, i) { return { p: p, i: i }; })
            .sort(function (a, b) { return pos(a.p) - pos(b.p) || a.i - b.i; }).map(function (x) { return x.p; });
          // fones (tipo Headphones / Intra-auriculares / Caixa de som) disponíveis primeiro; peças da coleção vão para relacionados
          var fones = items.filter(function (p) { return p.available && MAIN_TYPES.test(p.type || '') && !ACC_SET[p.handle]; });
          var rest = items.filter(function (p) { return fones.indexOf(p) === -1; });
          rest = rest.filter(function (p) { return p.available; }).concat(rest.filter(function (p) { return !p.available; }));
          var rec = fones.length ? fones.slice(0, REC_MAX) : rest.slice(0, REC_MAX);
          rest = items.filter(function (p) { return rec.indexOf(p) === -1; });
          renderResults(q, { products: rest, pages: [] }, rec);
        }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          suggest(q).then(function (data) { if (current === q) renderResults(q, data, null); });
        });
        return;
      }
      var acc = norm(q).match(ACC);
      if (acc && !acc[1]) {
        // só "acessório(s)": os acessórios mais vendidos, como recomendados
        renderResults(q, { products: [], pages: [] }, ACC_ITEMS);
        return;
      }
      if (acc) {
        // "acessórios para <fone>": busca o fone e fica só com o que está na coleção de acessórios
        suggest(acc[1]).then(function (data) {
          if (current !== q) return;
          var list = data.products.filter(function (p) { return ACC_SET[p.handle]; });
          // primeiro os que têm o nome do fone no título; se nenhum tiver, o termo não é um fone da Kuba
          var named = list.filter(function (p) { return inTitle(p.title, effective(acc[1])); });
          list = named.length ? named.concat(list.filter(function (p) { return named.indexOf(p) === -1; })) : [];
          var rest = ACC_ITEMS.filter(function (p) { return !list.some(function (x) { return x.handle === p.handle; }); });
          renderResults(q, { products: rest, pages: [] }, list.length ? list : ACC_ITEMS);
        }).catch(function (e) { if ((!e || e.name !== 'AbortError') && current === q) renderResults(q, { products: [], pages: [] }, ACC_ITEMS); });
        return;
      }
      suggest(q).then(function (data) { if (current === q) renderResults(q, data, null); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') { if (current === q) renderResults(q, { products: [], pages: [] }, null); } });
    }

    var t = null;
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { run(input.value); }, 250); });
    back.addEventListener('click', function (e) { e.preventDefault(); input.value = ''; renderEmpty(); input.focus(); });
    d.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-kbs-q]');
      if (!c) return;
      e.preventDefault();
      input.value = c.getAttribute('data-kbs-q');
      clearTimeout(t); run(input.value);
    });
    // Enter: nada acontece (os resultados já estão na gaveta)
    form.addEventListener('submit', function (e) { e.preventDefault(); }, true);

    if (input.value.trim()) run(input.value); else renderEmpty();
    return true;
  }

  if (!init()) document.addEventListener('DOMContentLoaded', init);
})();
